export default {"src":"/_next/static/media/qual4.43158be5.svg","height":22,"width":26,"blurWidth":0,"blurHeight":0};